import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { FC } from 'react';
import { Spinner } from 'react-bootstrap';
import { Center } from '../MetaComponent';

export const PageSpinner: FC = () => {
  return (
    <Container>
      <Spinner animation="border" />
    </Container>
  );
};

const Container = styled(Center)`
  background-color: white;
  width: 2.5rem;
  height: 2.5rem;
  border: solid 1px ${RacemapColors.LightGray};
  border-radius: 1.25rem;
  position: fixed;
  right: 50vw;
  transform: translateX(50%);
  top: 15vh;
  z-index: 1000;
`;
